import { ChangeDetectionStrategy, Component, forwardRef, input, model, output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

/** Switch del DS (52×32, On = teal). Funciona con ngModel/formControl o con [checked]/(toggled). */
@Component({
  selector: 'app-switch',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SwitchComponent), multi: true }],
  template: `
    <button type="button" role="switch" class="track" [class.is-on]="checked()" [attr.aria-checked]="checked()"
      [attr.aria-label]="label()" [disabled]="disabled()" (click)="toggle()">
      <span class="thumb"></span>
    </button>
  `,
  styles: [`
    :host{display:inline-flex;flex:none}
    .track{width:52px;height:32px;border-radius:999px;border:0;padding:2px;background:var(--cr-border-strong);cursor:pointer;
      transition:background var(--cr-motion-quick) var(--cr-ease-standard);display:flex}
    .track.is-on{background:var(--cr-brand-teal)}
    .track:disabled{opacity:.5;cursor:default}
    .thumb{width:28px;height:28px;border-radius:50%;background:#fff;box-shadow:0 2px 5px rgb(0 0 0 / .18);
      transition:transform var(--cr-motion-quick) var(--cr-ease-standard)}
    .is-on .thumb{transform:translateX(20px)}
  `],
})
export class SwitchComponent implements ControlValueAccessor {
  readonly checked = model<boolean>(false);
  readonly disabled = model<boolean>(false);
  readonly label = input<string>('');
  readonly toggled = output<boolean>();

  private onChange: (v: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  toggle(): void {
    const v = !this.checked();
    this.checked.set(v);
    this.onChange(v);
    this.onTouched();
    this.toggled.emit(v);
  }

  writeValue(v: boolean): void { this.checked.set(!!v); }
  registerOnChange(fn: (v: boolean) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState(d: boolean): void { this.disabled.set(d); }
}
